import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import HomeFilter from './HomeFilter';
import $ from 'jquery';
import 'datatables.net-dt';
const apiUrl = process.env.REACT_APP_API_URL;
const homeUrl = process.env.REACT_APP_HOME_URL;

const TopGainers = ({ currentPage, setCurrentPage, totalPages, setTotalPages, loading, setLoading }) => {
  const [coins, setCoins] = useState([]);
  const [error, setError] = useState(null);
  const dataTableRef = useRef(null); 
  const [currentPage1, setCurrentPage1] = useState(0);

  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const fetchTopGainers = async () => {
      const query = new URLSearchParams({ page_number: currentPage }).toString();
      setLoading(true);
      try {
        //const response = await fetch(`${apiUrl}/api/coins/markets?order=price_change_percentage_24h_desc&per_page=50`);
        const response = await fetch(`${apiUrl}/api/coins/top-gainers?${query}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        //const data = await response.json();
        let data = await response.json();
        // Client-side sorting (descending for gainers)
        /*data = data.sort((a, b) => 
          (b.price_change_percentage_24h || 0) - (a.price_change_percentage_24h || 0)
        );*/

        // Safely handle potential null/undefined values
        data = data
          .map(coin => ({
            ...coin,
            price_change_percentage_24h: coin.price_change_percentage_24h || 0,
            market_cap: coin.market_cap || 0,
            current_price: coin.current_price || 0
          }))
          .filter(coin => coin.price_change_percentage_24h > 0)
          .sort((a, b) => {
            // Safe comparison with fallback to 0
            const aChange = a.price_change_percentage_24h || 0;
            const bChange = b.price_change_percentage_24h || 0;
            return bChange - aChange;
          });


        setCoins(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching top gainers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopGainers();
    // Optional: Refresh data every 5 minutes
    const interval = setInterval(fetchTopGainers, 300000);
    return () => clearInterval(interval);
  }, [currentPage]);

  const handlePageChange = (direction) => {
    console.log(direction);
    setCurrentPage((prevPage) => {
      if (direction === 'prev') {
        return Math.max(prevPage - 1, 1); // Minimum page is 1
      } else if (direction === 'next') {
        return Math.min(prevPage + 1, totalPages); // Maximum page is totalPages
      }
      return prevPage;
    });
  };

  useEffect(() => {
    if (coins.length > 0) {
      setTimeout(() => {
        const table = $('#coin_list_table').DataTable({
          // ✅ Remove "Show X entries"
          lengthChange: false,

          // ✅ Remove search box
          searching: false,

          // ✅ Remove pagination and show only Next/Previous
          pagingType: 'simple', // Only “Previous” and “Next”
          pageLength: 20,       // Set how many rows per page

          // ✅ Disable column sorting globally
          ordering: false,

          // ✅ Set default ordering for a specific column (e.g., second column descending)
          order: [[3, 'desc']], // uncomment if you want default sort

          // ✅ Optional: disable info text like "Showing 1 to 10 of 50 entries"
          info: false,
      });
      dataTableRef.current = table;
      }, 0);
    }
  }, [coins]);

  const handleNext = () => {
    const table = dataTableRef.current;
    if (table && currentPage1 < table.page.info().pages - 1) {
      table.page(currentPage1 + 1).draw('page');
      setCurrentPage1(currentPage1 + 1);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrev = () => {
    const table = dataTableRef.current;
    if (table && currentPage1 > 0) {
      table.page(currentPage1 - 1).draw('page');
      setCurrentPage1(currentPage1 - 1);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

return (
  <>
    {path === '/top-gainers' && (
      <div className="toppagetitle">
        <div className="container">
          <div className="pagetitle">
            <h1>Top Gainers</h1>
          </div>
        </div>
      </div>
    )}
    <HomeFilter coins={coins} />
    <div className="btn_mainsec">
      <button
        className="btn_style"
        onClick={handlePrev} disabled={currentPage1 === 0}
      >
        Previous
      </button>

      <button
        className="btn_style"
        onClick={handleNext}
        disabled={
          dataTableRef.current &&
          currentPage1 >= dataTableRef.current.page.info().pages - 1
        }
      >
        Next
      </button>
    </div>
  </>
);


};

export default TopGainers;